<template>
  <div>
    <div class="toolbar">
      <el-input
        v-model="reqNo"
        clearable
        placeholder="单号"
        style="width:180px"
        @keyup.enter.native="load"
      />
      <el-date-picker
        v-model="applyRange"
        type="daterange"
        value-format="yyyy-MM-dd"
        start-placeholder="申请开始"
        end-placeholder="申请结束"
        style="width:260px"
        @change="load"
      />
      <el-select v-model="receiveStatus" clearable placeholder="收货状态" style="width:130px" @change="load">
        <el-option v-for="(v,k) in materialReceiveStatusMap" :key="k" :label="v.label" :value="k" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="load">查询</el-button>
    </div>

    <el-table :data="pageList" border v-loading="loading">
      <el-table-column prop="reqNo" label="单号" width="160" show-overflow-tooltip />
      <el-table-column prop="projectName" label="项目" min-width="140" show-overflow-tooltip />
      <el-table-column prop="stageName" label="工序" width="110" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.stageName || '-' }}</template>
      </el-table-column>
      <el-table-column label="使用日期" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.needDate) }}</template>
      </el-table-column>
      <el-table-column prop="createdByName" label="申请人" width="100" show-overflow-tooltip>
        <template slot-scope="{ row }">{{ row.createdByName || '-' }}</template>
      </el-table-column>
      <el-table-column prop="createdByPhone" label="联系电话" width="120">
        <template slot-scope="{ row }">{{ row.createdByPhone || '-' }}</template>
      </el-table-column>
      <el-table-column label="申请时间" width="120">
        <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
      </el-table-column>
      <el-table-column prop="receiveStatus" label="收货状态" width="110">
        <template slot-scope="{ row }">
          <el-tag size="mini" :type="statusType(materialReceiveStatusMap, row.receiveStatus || 'NONE')">
            {{ statusLabel(materialReceiveStatusMap, row.receiveStatus || 'NONE') }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="90" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="openDetail(row)">详情</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="listTotal"
      :page="page"
      :page-size="pageSize"
      @current-change="onPageChange"
      @size-change="onPageSizeChange"
    />

    <el-drawer title="申请详情" :visible.sync="detailVisible" size="720px">
      <div v-if="detail" style="padding:0 16px 16px">
        <p>单号：{{ detail.req.reqNo }}</p>
        <p>
          收货：{{ statusLabel(materialReceiveStatusMap, detail.req.receiveStatus || 'NONE') }}
          · 使用日期：{{ fmtDate(detail.req.needDate) }}
        </p>
        <p>项目：{{ detail.req.projectName }} / {{ detail.req.stageName || '-' }}</p>
        <p>
          申请人：{{ detail.req.createdByName || '-' }}
          · {{ detail.req.createdByPhone || detail.createdByPhone || '-' }}
          · {{ fmtDate(detail.req.createdAt) }}
        </p>
        <el-table :data="detail.lines" border size="small">
          <el-table-column prop="materialName" label="材料" min-width="110" />
          <el-table-column prop="unit" label="单位" width="60" />
          <el-table-column prop="qty" label="申请" width="70" />
          <el-table-column prop="receivedQty" label="已收" width="70" />
          <el-table-column prop="returnedQty" label="已退" width="70" />
          <el-table-column prop="actualQty" label="实收" width="70" />
          <el-table-column prop="costPrice" label="采购单价" width="90">
            <template slot-scope="{ row }">{{ formatMoney(row.costPrice) }}</template>
          </el-table-column>
          <el-table-column label="实收金额" width="90">
            <template slot-scope="{ row }">{{ formatMoney(lineAmount(row)) }}</template>
          </el-table-column>
        </el-table>
        <p style="margin-top:16px;font-weight:600">收货明细</p>
        <el-table :data="receiveLines" border size="small" empty-text="暂无收货明细">
          <el-table-column prop="receiveNo" label="收货单号" min-width="130" />
          <el-table-column prop="materialName" label="材料" min-width="120" />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="receiveQty" label="本次收货" width="90" />
          <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
            <template slot-scope="{ row }">{{ row.remark || '-' }}</template>
          </el-table-column>
          <el-table-column label="收货时间" width="120">
            <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
          </el-table-column>
          <el-table-column prop="createdByName" label="操作人" width="90" />
        </el-table>
        <p style="margin-top:16px;font-weight:600">退货明细</p>
        <el-table :data="returnLines" border size="small" empty-text="暂无退货明细">
          <el-table-column prop="returnNo" label="退货单号" min-width="130" />
          <el-table-column prop="materialName" label="材料" min-width="120" />
          <el-table-column prop="unit" label="单位" width="70" />
          <el-table-column prop="qty" label="本次退货" width="90" />
          <el-table-column label="退货时间" width="120">
            <template slot-scope="{ row }">{{ fmtDate(row.createdAt) }}</template>
          </el-table-column>
          <el-table-column prop="createdByName" label="操作人" width="90" />
        </el-table>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {
  listMaterialReqs, getMaterialReq,
  listMaterialReceiveLines, listMaterialReturnLines
} from '../../api/supply'
import {
  materialReceiveStatusMap, materialReturnStatusMap,
  statusLabel, statusType
} from '../../utils/status'
import ListPagination from '../../components/ListPagination.vue'
import listPaging from '../../mixins/listPaging'

export default {
  name: 'SupplierRequisition',
  components: { ListPagination },
  mixins: [listPaging],
  data() {
    return {
      materialReceiveStatusMap,
      materialReturnStatusMap,
      reqNo: '',
      applyRange: null,
      receiveStatus: '',
      list: [],
      loading: false,
      detailVisible: false,
      detail: null,
      receiveLines: [],
      returnLines: []
    }
  },
  created() {
    this.load()
  },
  methods: {
    statusLabel,
    statusType,
    num(v) {
      const n = Number(v)
      return Number.isFinite(n) ? n : 0
    },
    formatMoney(v) {
      return this.num(v).toFixed(2)
    },
    lineAmount(row) {
      if (row && row.amount != null && row.amount !== '') return this.num(row.amount)
      return Math.round(this.num(row && row.actualQty) * this.num(row && row.costPrice) * 100) / 100
    },
    fmtDate(v) {
      if (!v) return '-'
      return String(v).slice(0, 10)
    },
    async load() {
      this.loading = true
      try {
        const range = this.applyRange || []
        const res = await listMaterialReqs({
          reqNo: this.reqNo || undefined,
          startDate: range[0] || undefined,
          endDate: range[1] || undefined,
          receiveStatus: this.receiveStatus || undefined
        })
        this.list = res.data || []
        this.page = 1
      } finally {
        this.loading = false
      }
    },
    async openDetail(row) {
      const [d, recv, ret] = await Promise.all([
        getMaterialReq(row.id),
        listMaterialReceiveLines(row.id).catch(() => ({ data: [] })),
        listMaterialReturnLines(row.id).catch(() => ({ data: [] }))
      ])
      this.detail = d.data || null
      if (this.detail && this.detail.req && !this.detail.req.createdByPhone) {
        this.detail.createdByPhone = row.createdByPhone
      }
      this.receiveLines = recv.data || []
      this.returnLines = ret.data || []
      this.detailVisible = true
    }
  }
}
</script>

<style scoped>
.toolbar { display: flex; gap: 8px; margin-bottom: 12px; flex-wrap: wrap; }
</style>
